const sbitaQualifiedEmail = `
  <!DOCTYPE html>
  <html>
  <head>
  <meta content="text/html; charset=UTF-8" http-equiv="Content-Type" />
  <!-- [ if !mso]> <!-->
  <meta content="IE=edge" http-equiv="X-UA-Compatible" />
  <!-- <![endif] -->
  <meta content="telephone=no" name="format-detection" />
  <meta content="width=device-width, initial-scale=1.0" name="viewport" />
  <title>GASB 96 SBITA Identifier Results</title>
  <!--[if mso]>
  <style type="text/css">
  td {
  font-family: Arial, sans-serif !important;
  }
  </style>
  <![endif]-->
  <style type="text/css">
  .ExternalClass {
      width: 100%;
  }
  .ExternalClass, .ExternalClass p, .ExternalClass span, .ExternalClass font, .ExternalClass td, .ExternalClass div, .ExternalClass b, .ExternalClass br, .ExternalClass img {
      line-height: 100% !important;
  }
  body {
      margin: 0;
      padding: 0;
      -webkit-text-size-adjust: 100% !important;
      -ms-text-size-adjust: 100% !important;
  }
  body, #body_style {
      background: #E7F0F8;
      min-height: 1000px;
  }
  table td {
      border-collapse: collapse;
      border-spacing: 0 !important
  }
  table tr {
      border-collapse: collapse;
      border-spacing: 0 !important
  }
  table tbody {
      border-collapse: collapse;
      border-spacing: 0 !important
  }
  table {
      border-collapse: collapse;
      border-spacing: 0 !important
  }
  span.yshortcuts, a span.yshortcuts {
      color: #000001;
      background-color: none;
      border: none;
  }
  span.yshortcuts:hover, span.yshortcuts:active, span.yshortcuts:focus {
      color: #000001;
      background-color: none;
      border: none;
  }
  .yahooNone {
      display: none;
  }
  img {
      -ms-interpolation-mode: bicubic;
  }
  a[x-apple-data-detectors] {
      color: inherit !important;
      text-decoration: none !important;
      font-size: inherit !important;
      font-family: inherit !important;
      font-weight: inherit !important;
      line-height: inherit !important;
  }

  @media screen and (max-width: 500px) {
  .stack {
      width: 100% !important;
  }
  .hund {
      width: 100% !important;
      height: auto !important
  }
  .noMo {
      display: none !important
  }
  .block {
      display: block !important
  }
  .left {
      float: left !important;
      text-align: left !important
  }
  .right {
      float: right !important;
      text-align: right !important
  }
  .center {
      text-align: center !important;
      margin: 0 auto !important
  }
  .noPad {
      padding: 0 !important
  }
  .rePad {
      padding: 20px !important
  }
  .padB {
      padding-bottom: 20px !important
  }
  .padT {
      padding-top: 20px !important
  }
  .padL {
      padding-left: 20px !important
  }
  .padR {
      padding-right: 20px !important
  }
  .noBorder {
      border: none !important
  }
  .twentPX {
      font-size: 20px !important
  }
  .mobNavStyle {
      border-bottom: 1px solid #DDDDDD;
      padding: 10px 0;
      background-color: #FFFFFF;
  }
  }
  </style>
  </head>
  <body bgcolor="#E7F0F8" style="min-height: 1000px; background:#E7F0F8;">
  <div align="center" id="body_style">
    <table align="center" border="0" cellpadding="0" cellspacing="0" class="hund" width="100%">
      <tr>
        <td align="center" bgcolor="#E7F0F8" style="padding:30px 0"><table width="650" class="hund" cellspacing="0" cellpadding="0" border="0">
            <tr>
              <td align="center"><table border="0" cellpadding="0" cellspacing="0" width="100%">
                  <tr>
                    <td align="center"><img src="https://leasequery.com/wp-content/uploads/2021/06/leasequery-logo.png" width="175"  border="0" /></td>
                  </tr>
                </table></td>
            </tr>
          </table></td>
      </tr>
    </table>
    <table align="center" border="0" cellpadding="0" cellspacing="0" class="hund" width="650">
      <tr>
        <td align="center" style="background-color:#ffffff; padding-top:30px"><table width="100%" class="hund center" cellspacing="0" cellpadding="0" border="0">
            <tr>
              <td align="center" style="padding:20px 0"><table width="80%" class="hund" cellspacing="0" cellpadding="0" border="0">
                  <tr>
                    <td align="center" style="font-family:Arial,sans-serif; font-size:26px; line-height:32px; color:#154B82; padding-bottom:10px"><strong>Based on your answers, you may have a Subscription-Based IT Arrangement (SBITA) under GASB 96.</strong></td>
                  </tr>
                  <tr>
                    <td class="rePad" align="center" style="text-align:left; color:#333333; font-family:Arial,sans-serif; font-size:14px; line-height:16px; padding:16px 0">
                    <p>
                        Under GASB 96, a SBITA is defined as a contract that conveys control of the right to use another party’s (a SBITA vendor’s) IT software, alone or in combination with tangible capital assets (the underlying IT assets), as specified in the contract for a period of time in an exchange or exchange-like transaction.
                    </p>
                    <p>
                        Similar to GASB 87 - <em>Leases</em>, GASB 96 requires governments to record an intangible right-to-use subscription asset and a corresponding subscription liability on the statement of net position for the majority of SBITAs. The subscription liability is calculated as the present value of future subscription payments, while the subscription asset is equal to the subscription liability adjusted for certain costs such as prepaid service fees and capitalizable implementation costs. The amortization of both the subscription asset and liability are reported as outflows of resources.
                    </p
                    <p>
                        LeaseQuery is considering building a tool to account for SBITAs under GASB 96. Click <a href="https://docs.google.com/forms/d/e/1FAIpQLSc_zXAtpRKhGI5iWAy_PbpREsPNlyeziqNDyBQlAMOKKHm-zg/viewform" style="color:#F57E25">here</a> to express your interest and stay informed of our progress.
                    </p>
                    </td>
                  </tr>
                </table></td>
            </tr>
            <tr>
              <td bgcolor="#B6D6EC" align="center" style="padding:50px 0 30px"><table width="90%" class="hund" cellspacing="0" cellpadding="0" border="0">
                  <tr>
                    <td align="center" style="font-family:Arial,sans-serif; font-size:24px; line-height:32px; color:#154B82; padding-bottom:20px"><strong>Check out our other free tools</strong></td>
                  </tr>
                  <tr>
                    <td align="center"><center>
                        <table align="center" bgcolor="#154B82" cellpadding="12" cellspacing="0" style="border-collapse:separate;-moz-border-radius:2px;-webkit-border-radius:2px;border-radius:2px;">
                          <tbody>
                            <tr>
                              <td style="-webkit-text-size-adjust:none;">&nbsp;</td>
                              <td style="text-align: center; font-style: normal; color: #154B82; -webkit-text-size-adjust: none; text-decoration: none; font-size: 18px; font-family:Arial,sans-serif; font-weight:bold"><a href="https://leasequery.com/lease-accounting-tools/" style="color:#ffffff; text-decoration:none">FREE ACCOUNTING TOOLS</a></td>
                              <td style="-webkit-text-size-adjust:none;">&nbsp;</td>
                            </tr>
                          </tbody>
                        </table>
                      </center></td>
                  </tr>
                  <tr>
                    <td height="20">&nbsp;</td>
                  </tr>
                </table></td>
            </tr>
            <tr>
              <td align="center" style="padding:40px 0"><table width="80%" class="hund" cellspacing="0" cellpadding="0" border="0">
                  <tr>
                    <td align="center" style="font-family:Arial,sans-serif; font-size:21px; line-height:24px; color:#154B82; padding-bottom:20px"><strong>Did you find this tool useful?</strong></td>
                  </tr>
                  <tr>
                    <td class="rePad" align="center" style="text-align:center; color:#333333; font-family:Arial,sans-serif; font-size:14px; line-height:18px;">Please show your appreciation by sharing the tool.<br>
                      (Don't worry, we won't share your results) </td>
                  </tr>
                  <tr>
                    <td align="center" style="padding-top:30px"><table align="center" width="300" border="0" cellspacing="0" cellpadding="0">
                        <tbody>
                        <tr>
                        <td align="center"><a href="mailto:?&subject=GASB 96 SBITA Identifier&body=I just used this tool to do the GASB 96 SBITA Identifier test in seconds! You should try it: https://tools.leasequery.com/gasb-96-SBITA-identifier.html/"><img src="https://ci3.googleusercontent.com/proxy/JiNV1MJ15bUPuhBF2BBUX5WY4FMWHaBTCFzYqr1RBXJzSlsvlUgJf86tyh7zobB1lFM6OBUdGLrveYnRdprnSd_T8L5bwHNV9Hyd_mjG5gSZWNRlRvy0CBhnniL6FgVzXRo=s0-d-e1-ft#https://embeddedleasetool.leasequery.com/dist/Content/images/email_02_05_04.jpg" width="47" height="47" border="0" /></a></td>
                        <td align="center"><a href="https://www.linkedin.com/sharing/share-offsite/?url=https://tools.leasequery.com/gasb-96-SBITA-identifier.html/"><img src="https://ci6.googleusercontent.com/proxy/pkNKuyKlTYs76mAiY0GeZqn8WTS4azRp_29KRdF6NGirkHqbGPLJRiUs4m5icxH-rkfO5WFelyUW8qV4D-0YFltbgGqRupr0h_vTDuv9s0CS4RH75IcvikegpciGovDtZR8=s0-d-e1-ft#https://embeddedleasetool.leasequery.com/dist/Content/images/email_02_05_06.jpg" width="47" height="47" border="0" /></a></td>
                        <td align="center"><a href="http://www.facebook.com/sharer.php?u=https%3A//tools.leasequery.com/gasb-96-SBITA-identifier.html/&description=I just used this tool to do the GASB 96 SBITA Identifier test in seconds! You should try it."><img src="https://ci5.googleusercontent.com/proxy/FUHd_MHLyuHJgPvlEthakxoPOD1KCYrJsGzAd8PTBslNVQvZuagDAx1i6-IAUKTeLpW8nYcBkewT3bZ1mg5aaJ_K4aMN_ueVh35nraHXaN4WZQNNzibnO_UrSQxI-_JYLu8=s0-d-e1-ft#https://embeddedleasetool.leasequery.com/dist/Content/images/email_02_05_08.jpg" width="47" height="47" border="0" /></a></td>
                        <td align="center"><a href="https://pinterest.com/pin/create/button/?url=https%3A//tools.leasequery.com/gasb-96-SBITA-identifier.html/&media=&description=I just used this tool to do the GASB 96 SBITA Identifier test in seconds! You should try it."><img src="https://ci5.googleusercontent.com/proxy/Q_lGxtSX05U19ysRpnIBAFkLoU2OW-KkJ_Iwx8aihFOEhRkreRxJ8Il6VCglm7jMrnDMMBAEA0UxN1GsL_1BbBgMzknERoTsUhQw2WIdJCaX7i3AUQQ-ex-ocUxOn5jLBbM=s0-d-e1-ft#https://embeddedleasetool.leasequery.com/dist/Content/images/email_02_05_10.jpg" width="47" height="47" border="0" /></a></td>
                        <td align="center"><a href="http://twitter.com/share?text=I just used this tool to do the GASB 96 SBITA Identifier test in seconds! You should try it. &url=https%3A//tools.leasequery.com/gasb-96-SBITA-identifier.html/"><img src="https://ci6.googleusercontent.com/proxy/IDNFVwWsankbP8eRjiZECExIbLnpavXY37AJ4oH_n_yiSAGrm_nq-rSUkWbiL6wUZEOVcdjVjQfIC1aoHL7NPOiIHIavxFgke3bkZwYgERU-yjs-RRQP9HiQ_vrSLeTyDVM=s0-d-e1-ft#https://embeddedleasetool.leasequery.com/dist/Content/images/email_02_05_12.jpg" width="47" height="47" border="0" /></a></td>
                        </tr>
                        </tbody>
                      </table></td>
                  </tr>
                </table></td>
            </tr>
            <tr>
              <td bgcolor="#E7F0F8" align="center" style="padding:40px 0"><table width="80%" class="hund" cellspacing="0" cellpadding="0" border="0">
                  <tr>
                    <td class="rePad" align="center" style="text-align:center; color:#6D7E8F; font-family:Arial,sans-serif; font-size:10px; line-height:12px; padding:0px 0">Your use of this tool is governed by these <a target="_blank" style="color:#154B82" href="https://leasequery.com/terms-and-conditions/">terms and conditions</a>. <br>
                      <br>
                      Thank you for using our GASB 96 SBITA Identifier Tool,
                      Powered by <a style="color:#154B82" href="https://leasequery.com/" target="_blank">LeaseQuery.com</a></td>
                  </tr>
                </table></td>
            </tr>
          </table></td>
      </tr>
    </table>
  </div>
  </body>
  </html>
`

export default sbitaQualifiedEmail
